"use strict";
/* globals module */
/**
 * @module commerceProductFilesStreamsRoute
 * @description Baasic Product Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic product Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
;
var contracts_1 = require("../../../core/contracts");
var CommerceProductFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesStreamsRoute, _super);
    function CommerceProductFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'commerce/product-file-streams/{id}/{?width,height}';
        _this.createRoute = 'commerce/product-file-streams/{filename}/{?productId}';
        _this.updateRoute = 'commerce/product-file-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * @method
     * @param data Product file id of the original product file used to identify stream that needs to be retrieved from the system.
     * @example productFilesRoute.get({id: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param data Product file that needs to be saved into the system.
     * @example productFilesRoute.create({filename: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data Product file used to identify stream that needs to be updated.
     * @example productFilesRoute.update({id: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    CommerceProductFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductFilesStreamsRoute);
    return CommerceProductFilesStreamsRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesStreamsRoute = CommerceProductFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 
